// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3hbHi","footer":"ModalUpdate_footer__1k18f"};